import { Id } from "PFCore/types";

export const auditRolesKeys = {
  all: () => ["auditRoles"],
  withParameters: (filters: any, order: any, auditEngagementId: Id, page: number) => [
    ...auditRolesKeys.all(),
    { filters, order },
    { auditEngagementId },
    page
  ]
};
